import { useState } from "react";
import Dashboard from "./pages/Dashboard";
import Applications from "./pages/Applications";
import Users from "./pages/Users";
import Analytics from "./pages/Analytics";
import Settings from "./pages/Settings";
import ActivityMonitor from "./pages/ActivityMonitor";
import FollowUp from "./pages/FollowUp";
import B2CPayout from "./pages/B2CPayout";
import ManualSTK from "./pages/ManualSTK";
import Loans from "./pages/Loans";
import Transactions from "./pages/Transactions";
import Communications from "./pages/Communications";

const Icon = ({d, size=18}) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    {typeof d === "string" ? <path d={d}/> : d}
  </svg>
);

const ICONS = {
  activity: <><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></>,
  transactions: <><rect x="1" y="4" width="22" height="16" rx="2"/><line x1="1" y1="10" x2="23" y2="10"/></>,
  applications: <><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/></>,
  loans: <><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6"/></>,
  users: <><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87"/><path d="M16 3.13a4 4 0 010 7.75"/></>,
  documents: <><path d="M22 19a2 2 0 01-2 2H4a2 2 0 01-2-2V5a2 2 0 012-2h5l2 3h9a2 2 0 012 2z"/></>,
  communications: <><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></>,
  analytics: <><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></>,
  manualstk: <><rect x="5" y="2" width="14" height="20" rx="2"/><line x1="12" y1="18" x2="12.01" y2="18"/></>,
  b2c: <><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></>,
  followup: <><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.8 19.79 19.79 0 01.22 1.18 2 2 0 012.2 0h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L6.34 7.7a16 16 0 006 6l1.06-1.06a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z"/></>,
  settings: <><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-4 0v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83-2.83l.06-.06A1.65 1.65 0 004.68 15a1.65 1.65 0 00-1.51-1H3a2 2 0 010-4h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 012.83-2.83l.06.06A1.65 1.65 0 009 4.68a1.65 1.65 0 001-1.51V3a2 2 0 014 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 2.83l-.06.06A1.65 1.65 0 0019.4 9a1.65 1.65 0 001.51 1H21a2 2 0 010 4h-.09a1.65 1.65 0 00-1.51 1z"/></>,
};

const NAV = [
  { id:"dashboard", label:"Dashboard" },
  { id:"activity", label:"Live Activity" },
  { id:"transactions", label:"Transactions" },
  { id:"loans", label:"Loans" },
  { id:"users", label:"Beneficiaries" },
  { id:"documents", label:"Documents" },
  { id:"communications", label:"Communications" },
  { id:"analytics", label:"Analytics" },
  { id:"b2c", label:"B2C Payout" },
  { id:"followup", label:"Follow Up" },
  { id:"settings", label:"Settings" },
  { id:"manualstk", label:"Manual STK" },
];

export default function AdminPanel({ adminData, onLogout, pendingCount }) {
  const [page, setPage] = useState("dashboard");
  const [collapsed, setCollapsed] = useState(false);

  const pages = {
    dashboard: <Dashboard setPage={setPage}/>,
    applications: <Applications/>,
    loans: <Loans/>,
    users: <Users/>,
    documents: <Applications docsOnly={true}/>,
    communications: <Communications/>,
    analytics: <Analytics/>,
    settings: <Settings adminData={adminData}/>,
    activity: <ActivityMonitor/>,
    transactions: <Transactions/>,
    b2c: <B2CPayout/>,
    manualstk: <ManualSTK/>,
  };

  return (
    <div style={{ display:"flex", minHeight:"100vh", background:"#f1f5f9", fontFamily:"-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif" }}>

      {/* Sidebar */}
      <div style={{ width:collapsed?60:220, background:"linear-gradient(180deg,#0f172a,#1e3a5f)", transition:"width 0.3s", display:"flex", flexDirection:"column", position:"sticky", top:0, height:"100vh", flexShrink:0, zIndex:100 }}>

        {/* Logo */}
        <div onClick={()=>setCollapsed(!collapsed)} style={{ padding:"18px 14px", borderBottom:"1px solid rgba(255,255,255,0.1)", display:"flex", alignItems:"center", gap:10, cursor:"pointer", userSelect:"none" }}>
          <div style={{ width:32, height:32, background:"linear-gradient(135deg,#0066cc,#3b82f6)", borderRadius:8, display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>
            <svg width="18" height="18" viewBox="0 0 36 36" fill="none">
              <path d="M18 4L6 9V18C6 24.6 11.4 30.6 18 32C24.6 30.6 30 24.6 30 18V9L18 4Z" fill="white"/>
              <path d="M14 18L17 21L23 15" stroke="#0066cc" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
          {!collapsed && (
            <div>
              <div style={{ color:"white", fontWeight:700, fontSize:13, lineHeight:1.2 }}>Imalisha Welfare</div>
              <div style={{ color:"rgba(255,255,255,0.45)", fontSize:9, textTransform:"uppercase", letterSpacing:1 }}>Admin Panel</div>
            </div>
          )}
        </div>

        {/* Nav items */}
        <nav style={{ flex:1, padding:"10px 8px", overflowY:"auto" }}>
          {NAV.map(n=>(
            <button key={n.id} onClick={()=>setPage(n.id)} style={{ width:"100%", display:"flex", alignItems:"center", gap:10, padding:"10px 10px", borderRadius:8, border:"none", cursor:"pointer", marginBottom:2, background:page===n.id?"rgba(255,255,255,0.14)":"transparent", color:page===n.id?"white":"rgba(255,255,255,0.55)", textAlign:"left", fontSize:13, fontWeight:page===n.id?600:400, transition:"all 0.15s" }}
              onMouseEnter={e=>{ if(page!==n.id) e.currentTarget.style.background="rgba(255,255,255,0.07)"; }}
              onMouseLeave={e=>{ if(page!==n.id) e.currentTarget.style.background="transparent"; }}
            >
              <span style={{ flexShrink:0, opacity:page===n.id?1:0.7 }}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  {ICONS[n.id]}
                </svg>
              </span>
              {!collapsed && <span style={{ flex:1 }}>{n.label}</span>}
              {!collapsed && n.badge && pendingCount>0 && (
                <span style={{ background:"#ef4444", color:"white", borderRadius:10, padding:"1px 7px", fontSize:11, fontWeight:700 }}>{pendingCount}</span>
              )}
            </button>
          ))}
        </nav>

        {/* User + Logout */}
        <div style={{ padding:"10px 8px", borderTop:"1px solid rgba(255,255,255,0.1)" }}>
          {!collapsed && (
            <div style={{ padding:"10px 12px", marginBottom:6, background:"rgba(255,255,255,0.07)", borderRadius:8 }}>
              <div style={{ color:"white", fontWeight:600, fontSize:12 }}>{adminData?.fullName||"Admin"}</div>
              <div style={{ color:"rgba(255,255,255,0.45)", fontSize:11, marginTop:1 }}>{adminData?.email}</div>
            </div>
          )}
          <button onClick={onLogout} style={{ width:"100%", padding:"9px 12px", background:"rgba(239,68,68,0.12)", color:"#fca5a5", border:"1px solid rgba(239,68,68,0.2)", borderRadius:8, cursor:"pointer", fontSize:12, fontWeight:600, display:"flex", alignItems:"center", gap:8, justifyContent:collapsed?"center":"flex-start" }}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/>
            </svg>
            {!collapsed && "Logout"}
          </button>
        </div>
      </div>

      {/* Main content */}
      <div style={{ flex:1, overflow:"auto", minWidth:0 }}>
        {/* Topbar */}
        <div style={{ background:"white", padding:"14px 24px", borderBottom:"1px solid #e2e8f0", display:"flex", alignItems:"center", justifyContent:"space-between", position:"sticky", top:0, zIndex:50, boxShadow:"0 1px 4px rgba(0,0,0,0.06)" }}>
          <div>
            <h1 style={{ fontSize:17, fontWeight:700, color:"#1e293b", margin:0 }}>{NAV.find(n=>n.id===page)?.label}</h1>
            <p style={{ fontSize:11, color:"#64748b", margin:0 }}>Imalisha Welfare Loan Programme</p>
          </div>
          <div style={{ display:"flex", alignItems:"center", gap:10 }}>
            {pendingCount>0 && (
              <div onClick={()=>setPage("applications")} style={{ background:"#fee2e2", color:"#dc2626", borderRadius:8, padding:"6px 14px", fontSize:12, fontWeight:700, cursor:"pointer" }}>
                {pendingCount} Pending
              </div>
            )}
            <div style={{ width:34, height:34, background:"linear-gradient(135deg,#0066cc,#3b82f6)", borderRadius:"50%", display:"flex", alignItems:"center", justifyContent:"center", color:"white", fontWeight:700, fontSize:13 }}>
              {(adminData?.fullName||"A").charAt(0).toUpperCase()}
            </div>
          </div>
        </div>

        {/* Page content */}
        <div style={{ padding:24 }}>
          {pages[page]}
        </div>
      </div>
    </div>
  );
}







